import { useState, useEffect, createContext } from 'react';
import { useSuccessReactor } from '@livefree/reactive';
import { useSearchParams } from 'react-router';
import { reactive } from '@/core/reactive/reactive';

export const LoginContext = createContext();

export const LoginProvider = reactive.component(
  ({ services, children }) => {
    const [params] = useSearchParams();

    const [info, setInfo] = useState({
      logo: '',
      name: '',
      returnUrl: params.get('ReturnUrl'),
      isReady: false,
    });

    useEffect(() => {
      services.login.info(info.returnUrl);
    }, [services, info.returnUrl]);

    useSuccessReactor(services.login.info, payload => {
      setInfo(x => ({
        ...x,
        logo: payload.logoUrl,
        name: payload.name,
        isReady: true,
      }));
    });

    return <LoginContext.Provider value={info}>{children}</LoginContext.Provider>;
  },
  {
    name: 'LoginProvider',
  },
);
